import { ProductPriceRange } from '../sdk';

export const renderPriceRange = (priceRange: ProductPriceRange) =>
  [
    ...new Set([
      priceRange.minVariantPrice.amount,
      priceRange.maxVariantPrice.amount,
    ]),
  ]
    .map((price) => `$${parseFloat(price).toFixed(2)}`)
    .join(' - ');
